import Reset from './Reset'
import enhance from './Reset.enhancer'

export default enhance(Reset)



// WEBPACK FOOTER //
// ./src/containers/account/ResetPassword/index.js